import { hasNonEmptyLabel, isAudioInputDevice } from "../selectors";

export function checkHasAudioInputPermissions(
  devices: MediaDeviceInfo[],
): boolean {
  const audioInputDevices = devices.filter(isAudioInputDevice);

  if (audioInputDevices.length === 0) return false;

  return audioInputDevices.every(hasNonEmptyLabel);
}
